var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6214 7.58023C11.6214 9.15368 10.35 10.4251 8.77652 10.4251C7.20308 10.4251 5.93164 9.15368 5.93164 7.58023C5.93164 6.00679 7.20308 4.73535 8.77652 4.73535C10.35 4.73535 11.6214 6.00679 11.6214 7.58023Z",
    stroke: "#445374",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77585 14.1518C11.581 14.1518 14.1955 12.4989 16.0153 9.63807C16.7305 8.51759 16.7305 6.63422 16.0153 5.51372C14.1955 2.65291 11.581 1 8.77585 1C5.97065 1 3.35619 2.65291 1.5364 5.51372C0.8212 6.63422 0.8212 8.51759 1.5364 9.63807C3.35619 12.4989 5.97065 14.1518 8.77585 14.1518Z",
    stroke: "#445374",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.49fe3d6645a1a59c0b3daf3794b9ca86.svg";
export { ForwardRef as ReactComponent };